import { Renderer2, RendererFactory2 } from '@angular/core';
import * as i0 from "@angular/core";
var BeaconChatService = /** @class */ (function () {
    function BeaconChatService(rendererFactory) {
        this.rendererFactory = rendererFactory;
        this.beaconElement = null;
        // Possible Beacon Chat selectors
        this.beaconSelectors = [
            '.beacon-chat-button',
            '#beacon-container',
            '[data-beacon]',
            '.beacon-button',
            '#Beacon',
            '.Beacon-container',
            'iframe[src*="beacon"]'
        ];
        // Create a renderer instance in the service since we don't have access to the component's renderer
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    /**
     * Hides the Beacon chat button
     * @returns Promise that resolves when the button is hidden or max attempts are reached
     */
    BeaconChatService.prototype.hideBeaconChat = function () {
        var _this = this;
        return new Promise(function (resolve) {
            // Try to find and hide the element immediately
            if (_this.findAndToggleBeacon(false)) {
                resolve(true);
                return;
            }
        });
    };
    /**
     * Shows the Beacon chat button
     * @returns Promise that resolves when the button is shown or not found
     */
    BeaconChatService.prototype.showBeaconChat = function () {
        var _this = this;
        return new Promise(function (resolve) {
            // If we already have a reference to the element, show it
            if (_this.beaconElement) {
                _this.setElementVisibility(_this.beaconElement, true);
                resolve(true);
                return;
            }
            // Otherwise try to find it one more time
            var found = _this.findAndToggleBeacon(true);
            resolve(found);
        });
    };
    /**
     * Finds the Beacon chat element and toggles its visibility
     * @param show Whether to show or hide the element
     * @returns Whether the element was found
     */
    BeaconChatService.prototype.findAndToggleBeacon = function (show) {
        for (var _i = 0, _a = this.beaconSelectors; _i < _a.length; _i++) {
            var selector = _a[_i];
            var element = document.querySelector(selector);
            if (element) {
                if (!show) {
                    this.beaconElement = element;
                    this.setElementVisibility(element, false);
                }
                else {
                    this.setElementVisibility(element, true);
                }
                return true;
            }
        }
        return false;
    };
    /**
     * Sets the visibility of an element
     * @param element The element to set visibility for
     * @param visible Whether the element should be visible
     */
    BeaconChatService.prototype.setElementVisibility = function (element, visible) {
        if (visible) {
            this.renderer.setStyle(element, 'display', '');
            this.renderer.setStyle(element, 'visibility', '');
            this.renderer.setStyle(element, 'opacity', '');
        }
        else {
            this.renderer.setStyle(element, 'display', 'none');
            this.renderer.setStyle(element, 'visibility', 'hidden');
            this.renderer.setStyle(element, 'opacity', '0');
        }
    };
    BeaconChatService.ngInjectableDef = i0.defineInjectable({ factory: function BeaconChatService_Factory() { return new BeaconChatService(i0.inject(i0.RendererFactory2)); }, token: BeaconChatService, providedIn: "root" });
    return BeaconChatService;
}());
export { BeaconChatService };
